// extracted by mini-css-extract-plugin
export var background = "index-module--background--S47vA";
export var bio = "index-module--bio--MNqFW";
export var container = "index-module--container--HMNL1";
export var thumbnail = "index-module--thumbnail--yWv5Z";
export var title = "index-module--title--PbkEN";